import { IStore } from "../Store/store.interface";

export interface ILoginForm {
  identifier: string;
  password: string;
}

export interface Permission {
  resource: string;
  actions: string;
}

export interface IRole {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  permissions: Permission[];
}

export interface IRoleResponse {
  data: IRole[];
  message: string;
  status: boolean;
}

export enum Types {
  ADMIN = "admin",
  STORE_MANAGER = "store",
  STAFF = "staff",
  CUSTOMER = "customer",
  DRIVER = "driver",
}

export interface User {
  id: string;
  roleId: string;
  fullName: string;
  email: string;
  countryCode: string;
  phone: string;
  password: string;
  verificationToken: string | null;
  dob: string | null;
  type: Types,
  gender: string | null;
  isOnline: boolean;
  isBlocked: boolean;
  isVerified: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  accessToken: string;
  refreshToken: string;
  storeProfile?: IStore;
  /** Populated by /user/logged-in endpoint — carries the user's own permissions */
  role?: IRole;
}

export interface ILoginResponse {
  data: User;
  message: string;
  status: boolean;
}